var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9332 11.2998C12.9332 9.47625 14.4094 8 16.233 8C18.0566 8 19.5329 9.47625 19.5329 11.2998C19.5329 13.1234 18.0566 14.5997 16.233 14.5997C14.4094 14.5997 12.9332 13.1234 12.9332 11.2998ZM14.8922 15.6996H17.5739C20.2736 15.6996 22.4661 18.1876 22.4661 21.2513V23.5131C22.4661 23.8627 22.2305 24.13 21.9225 24.13H10.5436C10.2356 24.13 10 23.8627 10 23.5131V21.2513C10 18.1876 12.1924 15.6996 14.8922 15.6996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0741555317489c5282769e721a16b06a.svg";
export { ForwardRef as ReactComponent };